export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6686.1dc9b65a.jpg";